"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromise = exports.isObject = exports.isSymbol = exports.isString = exports.isFunction = exports.isDate = exports.isSet = exports.isMap = exports.isArray = void 0;
var objectToString = Object.prototype.toString;
var toTypeString = function (value) { return objectToString.call(value); };
exports.isArray = Array.isArray;
var isMap = function (val) { return toTypeString(val) === '[object Map]'; };
exports.isMap = isMap;
var isSet = function (val) { return toTypeString(val) === '[object Set]'; };
exports.isSet = isSet;
var isDate = function (val) { return val instanceof Date; };
exports.isDate = isDate;
var isFunction = function (val) { return typeof val === 'function'; };
exports.isFunction = isFunction;
var isString = function (val) { return typeof val === 'string'; };
exports.isString = isString;
var isSymbol = function (val) { return typeof val === 'symbol'; };
exports.isSymbol = isSymbol;
var isObject = function (val) { return val !== null && typeof val === 'object'; };
exports.isObject = isObject;
var isPromise = function (val) { return exports.isObject(val) && exports.isFunction(val.then) && exports.isFunction(val.catch); };
exports.isPromise = isPromise;
